import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { TagList } from 'core/components/JianDetail/PatientDetailInfo/common/TagList';
import { PatientCpaModeForSendai } from 'sections/sendai/features/useIncidentDetailForSendai';

type Props = {
  cpaMode: PatientCpaModeForSendai;
};

export const CpaModeView = ({ cpaMode }: Props) => {
  return (
    <BorderedContainer>
      <div className="flex flex-col gap-[24px]">
        <SectionTitle text="CPAモード" />

        {!cpaMode.isCpa ? (
          <p className="text-gray-500">CPA事案ではありません</p>
        ) : (
          <div className="flex flex-col gap-[24px]">
            {/* 目撃・最終健常確認・初期波形 */}
            <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
              <InfoDisplay
                title="目撃"
                content={
                  cpaMode.hasCpa === true
                    ? 'あり'
                    : cpaMode.hasCpa === false
                      ? 'なし'
                      : ''
                }
              />
              <InfoDisplay
                title="最終健常確認日時"
                content={cpaMode.lastHealthedAt ?? ''}
              />
              <InfoDisplay
                title="初期波形"
                content={cpaMode.initialEcg ?? ''}
              />
            </div>

            {/* 既往の有無 */}
            <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
              <InfoDisplay
                title="既往の有無"
                content={
                  cpaMode.isMedicalHistory === true
                    ? 'あり'
                    : cpaMode.isMedicalHistory === false
                      ? 'なし'
                      : ''
                }
              />
            </div>

            {/* 既往等 */}
            <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
              <InfoDisplay
                title="既往等"
                content={<TagList tags={cpaMode.medicalHistory ?? []} />}
              />
            </div>

            {/* 既往等 自由入力欄 */}
            <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
              <InfoDisplay
                title="既往等 自由入力欄"
                content={cpaMode.medicalHistoryComment ?? ''}
              />
            </div>
          </div>
        )}
      </div>
    </BorderedContainer>
  );
};
